import memoize from 'memoize-one';
export const getCoreUsage = memoize((state) => {
    const coreUsageStore = state.get('vNextCoreUsageStore');
    return coreUsageStore.get('coreUsage');
});
